(() => {
  const cart = document.querySelector('[data-lr-cart]');
  if (!cart) return;
  const error = cart.querySelector('.lr-cart-error');
  const showError = message => {
    error.textContent = message;
    error.hidden = false;
    error.focus();
  };
  let pending = false;
  const update = async (path, body, control) => {
    if (pending) return;
    pending = true;
    control.disabled = true;
    cart.setAttribute('aria-busy','true');
    error.hidden = true;
    try {
      const response = await fetch(cart.dataset.root + path, {
        method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || (window.lrT&&window.lrT["unable_to_update_your_cart_please_2b04"]||'Unable to update your cart. Please try again.'));
      if (body.discount && Array.isArray(data.discount_codes) && data.discount_codes.some(code => code.applicable === false)) {
        throw new Error(document.documentElement.lang === 'es' ? 'Este código no se puede aplicar a este carrito.' : 'This discount code cannot be applied to this cart.');
      }
      // Reload the server-rendered cart: Shopify owns prices, plans and transforms.
      window.location.reload();
    } catch (e) {
      showError(e.message || (window.lrT&&window.lrT["unable_to_update_your_cart_please_2b04"]||'Unable to update your cart. Please try again.'));
      control.disabled = false;
      cart.removeAttribute('aria-busy');
      pending = false;
    }
  };
  const replaceBundlePlan = async (select, plan) => {
    if (pending) return;
    pending = true;
    select.disabled = true;
    cart.setAttribute('aria-busy','true');
    error.hidden = true;
    let addedKey, previousQuantity;
    const request = async (path, body) => {
      const response = await fetch(cart.dataset.root + path, {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || (window.lrT&&window.lrT["unable_to_update_your_cart_ad02"]||'Unable to update your cart.'));
      return data;
    };
    try {
      const baselineResponse = await fetch(cart.dataset.root+'cart.js', {credentials:'same-origin'});
      if (!baselineResponse.ok) throw new Error((window.lrT&&window.lrT["unable_to_read_your_cart_please_8f26"]||'Unable to read your cart. Please try again.'));
      const baseline = await baselineResponse.json();
      // Expanded bundle components cannot receive the parent's selling plan.
      // Add the original parent with its plan, then remove its one-time line.
      const properties = JSON.parse(select.dataset.properties || '{}');
      const normalizedProperties = Array.isArray(properties) ? Object.fromEntries(properties) : (properties || {});
      const added = await request('cart/add.js', {items:[{
        id:Number(select.dataset.variant), quantity:Number(select.dataset.quantity),
        selling_plan:plan, properties:normalizedProperties
      }]});
      addedKey = added.items[0].key;
      previousQuantity = baseline.items.find(item => item.key === addedKey)?.quantity || 0;
      await request('cart/change.js', {id:select.dataset.key, quantity:0});
      window.location.reload();
    } catch (e) {
      if (addedKey) {
        try {await request('cart/change.js', {id:addedKey,quantity:previousQuantity});}
        catch (_) {e = new Error((window.lrT&&window.lrT["your_cart_could_not_be_updated_100f"]||'Your cart could not be updated completely. Reload the cart and check its items before checkout.'));}
      }
      showError(e.message);
      select.disabled = false;
      cart.removeAttribute('aria-busy');
      pending = false;
    }
  };
  cart.querySelectorAll('.lr-cart-plan-select').forEach(select => {
    const original = select.value;
    select.addEventListener('change', async () => {
      // Only show plans returned by THIS variant's allocations in Liquid.
      const plan = select.value ? Number(select.value) : null;
      if (plan && !original && select.dataset.bundle === 'true') await replaceBundlePlan(select,plan);
      else await update('cart/change.js', {line:Number(select.dataset.line), quantity:Number(select.dataset.quantity), selling_plan:plan}, select);
      if (!pending) select.value = original;
    });
  });
  cart.querySelector('[data-apply-discount]')?.addEventListener('click', event => {
    const discount = cart.querySelector('#lr-discount').value.trim();
    if (discount) update('cart/update.js', {discount}, event.currentTarget);
  });
  cart.querySelector('#lr-discount')?.addEventListener('keydown', event => {
    if (event.key === 'Enter') {event.preventDefault();cart.querySelector('[data-apply-discount]').click();}
  });
  cart.querySelector('form')?.addEventListener('submit',event => {
    if (pending) {event.preventDefault();return;}
    // Native cart POST preserves quantities, notes and Shopify checkout behavior.
    pending = true;
    cart.setAttribute('aria-busy','true');
  });
})();
